import store from '@/store'

export function cancel() {
  return new Promise((resolve, reject) => {
    store.dispatch('Cancel').then(() => {
      resolve();
    }).catch(error => {
      reject(error);
    })
  })
}

export function logout() {
  store.dispatch('Logout').then(() => {
    localLogout();
  }).catch((error) => {
    localLogout();
  })
}

function localLogout() {
  store.dispatch('ClearToken').then(() => {
    window.location.href = store.getters.objApi.LOCAL_URL;
  })
}



// WEBPACK FOOTER //
// ./src/utils/logout.js